const isTesting = false;
export const Log = (...args: any) => {
  if (isTesting) {
    console.log(...args);
  }
};
export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export const getMime = (ext: string) => {
  return mime[ext] ?? "application/octet-stream";
};
export const downloadData = (data: Uint8Array, filename: string, ext: string) => {


  // tslint:disable-next-line:one-variable-per-declaration
  let blob: any, url: string;

  blob = new Blob([data], {
    type: getMime(ext)
  });

  url = window.URL.createObjectURL(blob);

  downloadURL(url, filename);

  setTimeout(() => {
    return window.URL.revokeObjectURL(url);
  }, 1000);

};
export const TextToClipboard = (text: string) => {
  // Create a new clipboard object
  const clipboard = navigator.clipboard;
  // Write the text to the clipboard
  clipboard.writeText(text)
    .then(() => {
      // console.log('Text copied to clipboard');
    })
    .catch((error) => {
      console.error('Failed to copy text: ', error);
    });
};

const downloadURL = (data: any, filename: string) => {
  let a: any;
  a = document.createElement('a');
  a.href = data;
  a.download = filename;
  document.body.appendChild(a);
  a.style = 'display: none';
  a.click();
  a.remove();
};

export const mime: any = {
  html: "text/html",
  htm: "text/html",
  shtml: "text/html",
  css: "text/css",
  xml: "text/xml",
  gif: "image/gif",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  js: "application/x-javascript",
  atom: "application/atom+xml",
  rss: "application/rss+xml",
  mml: "text/mathml",
  txt: "text/plain",
  jad: "text/vnd.sun.j2me.app-descriptor",
  wml: "text/vnd.wap.wml",
  htc: "text/x-component",
  png: "image/png",
  tiff: "image/tiff",
  tif: "image/tiff",
  wbmp: "image/vnd.wap.wbmp",
  ico: "image/x-icon",
  jng: "image/x-jng",
  bmp: "image/x-ms-bmp",
  svg: "image/svg+xml",
  webp: "image/webp",
  jar: "application/java-archive",
  war: "application/java-archive",
  ear: "application/java-archive",
  hqx: "application/mac-binhex40",
  doc: "application/msword",
  pdf: "application/pdf",
  ps: "application/postscript",
  eps: "application/postscript",
  ai: "application/postscript",
  rtf: "application/rtf",
  xls: "application/vnd.ms-excel",
  ppt: "application/vnd.ms-powerpoint",
  wmlc: "application/vnd.wap.wmlc",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  "7z": "application/x-7z-compressed",
  cco: "application/x-cocoa",
  jardiff: "application/x-java-archive-diff",
  jnlp: "application/x-java-jnlp-file",
  run: "application/x-makeself",
  pl: "application/x-perl",
  pm: "application/x-perl",
  prc: "application/x-pilot",
  pdb: "application/x-pilot",
  rar: "application/x-rar-compressed",
  rpm: "application/x-redhat-package-manager",
  sea: "application/x-sea",
  swf: "application/x-shockwave-flash",
  sit: "application/x-stuffit",
  tcl: "application/x-tcl",
  tk: "application/x-tcl",
  der: "application/x-x509-ca-cert",
  pem: "application/x-x509-ca-cert",
  crt: "application/x-x509-ca-cert",
  xpi: "application/x-xpinstall",
  xhtml: "application/xhtml+xml",
  zip: "application/zip",
  bin: "application/octet-stream",
  exe: "application/octet-stream",
  dll: "application/octet-stream",
  deb: "application/octet-stream",
  dmg: "application/octet-stream",
  eot: "application/octet-stream",
  iso: "application/octet-stream",
  img: "application/octet-stream",
  msi: "application/octet-stream",
  msp: "application/octet-stream",
  msm: "application/octet-stream",
  mid: "audio/midi",
  midi: "audio/midi",
  kar: "audio/midi",
  mp3: "audio/mpeg",
  ogg: "audio/ogg",
  ra: "audio/x-realaudio",
  "3gpp": "video/3gpp",
  "3gp": "video/3gpp",
  mpeg: "video/mpeg",
  mpg: "video/mpeg",
  mov: "video/quicktime"
};

export const notes_template = `<p><strong><span data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;BILLING&quot;}" data-sheets-userformat="{&quot;2&quot;:16961,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0,&quot;12&quot;:0,&quot;17&quot;:1}">BILLING</span></strong></p>
<table dir="ltr" style="width: 100%; border-collapse: collapse; border-width: 1px; border-spacing: 0px;" border="1" cellspacing="0" cellpadding="0"><colgroup><col style="width: 16.1962%;" width="201"><col style="width: 34.8018%;" width="201"><col style="width: 48.9902%;" width="201"></colgroup>
<tbody>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03O/30O&quot;}">03O/30O</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Ocean Shipment/ Dry Cargo Entry&quot;}">
<div>
<div>Ocean Shipment/ Dry Cargo Entry</div>
</div>
</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03C&quot;}">03C</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Inbond Charge&quot;}">Inbond Charge</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03V&quot;}">03V</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Inbond Validation&quot;}">Inbond Validation</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:24}">24</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;FDA&quot;}">FDA</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:25}">25</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;NOAA&quot;}">NOAA</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:21}">21</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Special Messenger Fee&quot;}">Special Messenger Fee</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O6&quot;}">O6</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Add'l FDA Lines&quot;}">Add'l FDA Lines</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O6&quot;}">O6</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Add'l NOAA Lines&quot;}">Add'l NOAA Lines</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03R&quot;}">03R</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Remote Entry Fee&quot;}">Remote Entry Fee</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03+&quot;}">03+</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;10+2&quot;}">10+2</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;YES&quot;}">YES</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:21}">21</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Pier Pass&quot;}">Pier Pass</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:6}">6</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Add'I Lines&quot;}">Add'I Lines</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;22P&quot;}">22P</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Fedex&quot;}">Fedex</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;22P&quot;}">22P</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Fedex&quot;}">Fedex</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;22P&quot;}">22P</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Fedex&quot;}">Fedex</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:14}">14</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Cartages and Services&quot;}">Cartages and Services</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 11.7557px;">
<td style="height: 11.7557px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;03F&quot;}">02I</td>
<td style="height: 11.7557px; padding: 5px;">Fish and Wildlife Services</td>
<td style="height: 11.7557px; padding: 5px;">&nbsp;</td>
</tr>
</tbody>
</table>
<p><strong><span data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Fish and Wildlife Services&quot;}" data-sheets-userformat="{&quot;2&quot;:65,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0}">Fish and Wildlife Services</span></strong></p>
<table dir="ltr" style="width: 100%; border-collapse: collapse; border-width: 1px; border-spacing: 0px;" border="1" cellspacing="0" cellpadding="0"><colgroup><col style="width: 10.5744%;" width="201"><col style="width: 31.1786%;" width="201"><col style="width: 58.2352%;"></colgroup>
<tbody>
<tr style="height: 28.75px;">
<td style="height: 28.75px; padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:21}">03F</td>
<td style="height: 28.75px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Fish and Wildlife Transmission&quot;}">Fish and Wildlife Transmission</td>
<td style="height: 28.75px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 23.75px;">
<td style="height: 23.75px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">O7</td>
<td style="height: 23.75px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;ISF BOND&quot;}">ISF BOND</td>
<td style="height: 23.75px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">O7</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Single Entry Bond&quot;}">Single Entry Bond</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">31</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Single Entry Bond&quot;}">Set Up Domestic Company</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr><tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">32</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Single Entry Bond&quot;}">Customs Assigned Number (Foreign Importer)</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr><tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">33</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Single Entry Bond&quot;}">U.S Customs 5106 Set Up</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr><tr style="height: 22.3864px;">
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;O7&quot;}">03B</td>
<td style="height: 22.3864px; padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Single Entry Bond&quot;}">Continuous Bond</td>
<td style="height: 22.3864px; padding: 5px;">&nbsp;</td>
</tr></tbody>
</table>
<p><strong><span data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Examination Fees (021 AND 02A) Please Specify Code&quot;}" data-sheets-userformat="{&quot;2&quot;:65,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0}">Examination Fees (021 AND 02A) Please Specify Code</span></strong></p>
<table dir="ltr" style="width: 100%; border-collapse: collapse; border-width: 1px; border-spacing: 0px;" border="1" cellspacing="0" cellpadding="0"><colgroup><col style="width: 18.2273%;" width="201"><col style="width: 81.7508%;" width="201"></colgroup>
<tbody>
<tr style="height: 22.3864px;">
<td style="padding: 5px; height: 22.3864px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;02I&quot;}">02I</td>
<td style="padding: 5px; height: 22.3864px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="padding: 5px; height: 22.3864px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;02A&quot;}">02A</td>
<td style="padding: 5px; height: 22.3864px;">&nbsp;</td>
</tr>
<tr style="height: 22.3864px;">
<td style="padding: 5px; height: 22.3864px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;02A&quot;}">02A</td>
<td style="padding: 5px; height: 22.3864px;">&nbsp;</td>
</tr>
</tbody>
</table>
<p><strong><span data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Miscellaneous Charges: Please Specify Code&quot;}" data-sheets-userformat="{&quot;2&quot;:65,&quot;3&quot;:{&quot;1&quot;:0},&quot;9&quot;:0}">Miscellaneous Charges: Please Specify Code</span></strong></p>
<table dir="ltr" style="border-collapse: collapse; border-width: 1px; border-spacing: 0px; width: 100%;" border="1" cellspacing="0" cellpadding="0"><colgroup><col style="width: 26.5125%;" width="201"><col style="width: 73.3953%;" width="201"></colgroup>
<tbody>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Import Export&quot;}">Import Export</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Documents Transfers&quot;}">Documents Transfers</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Port Security Fee&quot;}">Port Security Fee</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:3,&quot;3&quot;:7501}">7501</td>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;Duty&quot;}">Duty</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;CMD FEE CSAV&quot;}">CMD FEE CSAV</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;WDT   6043&quot;}">WDT 6043</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
<tr>
<td style="padding: 5px;" data-sheets-value="{&quot;1&quot;:2,&quot;2&quot;:&quot;6043 VALIDATION&quot;}">6043 VALIDATION</td>
<td style="padding: 5px;">&nbsp;</td>
</tr>
</tbody>
</table>
<p><strong>Escrow Account Charges / No Billing</strong></p>`;

export const uuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, (c) => {
      // tslint:disable-next-line:no-bitwise
      const r = Math.random() * 16 | 0;
      // tslint:disable-next-line:no-bitwise
      const v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
};

export const minifyHtml = (html: string) => {
  return html.replace(/\n[ ]*/g, "");
};
export const preventReload = () => {
  return window.addEventListener('beforeunload', (e: any) => {
    // @ts-ignore
    e.preventDefault();
    e.returnValue = '';
  });
};

export const enableReload = (listener: any) => {
  // @ts-ignore
  window.removeAllListeners();
};
